import { c as _c } from "react/compiler-runtime";
import { Image } from '@petsmart-ui/sparky';
import { useState } from 'react';
import { decodeEntityString } from '@libs/algolia';
import type { ProductSearchItem } from '../../../search.types';
import ProductImageFallback from './product-image-fallback.icon.svg';
import { ProductPrice } from './product-price';
type ProductResultProps = {
  product: ProductSearchItem;
};
export function ProductResult(t0) {
  const $ = _c(20);
  const {
    product
  } = t0;
  const imageUrl = product.image.small ?? product.image.large;
  const [failedImageUrl, setFailedImageUrl] = useState();
  const showImageFallback = !imageUrl || failedImageUrl === imageUrl;
  let t1;
  if ($[0] !== product.label || $[1] !== showImageFallback) {
    t1 = showImageFallback && <ProductImageFallback aria-label={`${product.label} image unavailable`} className="header-search__product-image" role="img" />;
    $[0] = product.label;
    $[1] = showImageFallback;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== imageUrl || $[4] !== product.label || $[5] !== showImageFallback) {
    t2 = !showImageFallback && <Image className="header-search__product-image" src={imageUrl} alt={`${product.label} image`} loading="lazy" onError={() => setFailedImageUrl(imageUrl)} width={64} height={64} />;
    $[3] = imageUrl;
    $[4] = product.label;
    $[5] = showImageFallback;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== product.label) {
    t3 = decodeEntityString(product.label);
    $[7] = product.label;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="header-search__product-name">{t3}</div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== product.price) {
    t5 = product.price && <ProductPrice price={product.price} />;
    $[11] = product.price;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className="header-search__product-main">{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t6) {
    t7 = <div className="header-search__product">{t1}{t2}{t6}</div>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}